"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rubberbandModifier = void 0;
var _constants = require("./constants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var rubberbandModifier = function rubberbandModifier(_ref) {
  var draggingNodeRect = _ref.draggingNodeRect,
    transform = _ref.transform,
    windowRect = _ref.windowRect;
  if (!draggingNodeRect || !windowRect) {
    return transform;
  }
  return rubberbandBoundingRect(transform, draggingNodeRect, _objectSpread(_objectSpread({}, windowRect), {}, {
    top: (1 - _constants.MAX_DRAWER_HEIGHT_PERCENT) * windowRect.height,
    height: _constants.MAX_DRAWER_HEIGHT_PERCENT * windowRect.height
  }));
};
exports.rubberbandModifier = rubberbandModifier;
function rubberbandBoundingRect(transform, rect, boundingRect) {
  var value = _objectSpread({}, transform);

  // Dragging above the top edge of the bounding box
  if (rect.top + transform.y <= boundingRect.top) {
    var min = boundingRect.top - rect.top;
    var max = min + rect.height;
    value.y = rubberbandIfOutOfBounds(transform.y, min, max);
  }
  // Dragging below the bottom edge of the bounding box
  else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) {
    var boundingRectBottom = boundingRect.top + boundingRect.height;
    var _min = boundingRectBottom - rect.bottom;
    var _max = _min - rect.height;
    value.y = rubberbandIfOutOfBounds(transform.y, _max, _min);
  }

  // Draging beyond the left edge of the bounding box
  if (rect.left + transform.x <= boundingRect.left) {
    var _min2 = boundingRect.left - rect.left;
    var _max2 = _min2 + rect.width;
    value.x = rubberbandIfOutOfBounds(transform.x, _min2, _max2);
  }
  // Draging beyond the right edge of the bounding box
  else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) {
    var boundingRectRight = boundingRect.left + boundingRect.width;
    var _min3 = boundingRectRight - rect.right;
    var _max3 = _min3 - rect.width;
    value.x = rubberbandIfOutOfBounds(transform.x, _max3, _min3);
  }
  return value;
}
function clamp(v, min, max) {
  return Math.max(min, Math.min(v, max));
}
function rubberbandIfOutOfBounds(position, min, max) {
  var elasticity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.3;
  if (elasticity === 0) return clamp(position, min, max);
  if (position < min) return -rubberband(min - position, max - min, elasticity) + min;
  if (position > max) return +rubberband(position - max, max - min, elasticity) + max;
  return position;
}
function rubberband(distance, dimension, elasticity) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return Math.pow(distance, elasticity * 5);
  return distance * dimension * elasticity / (dimension + elasticity * distance);
}